<section class="header">
  <edge-global-header></edge-global-header>
</section>

<section class="content">
  <edge-press-content></edge-press-content>
</section>

<section class="footer">
  <edge-global-footer></edge-global-footer>
</section>
